import { FlexRowAlignCenter } from "@/components/Flex";
import noop from "@knowt/syncing/utils/noop";
import Skeleton from "@mui/material/Skeleton";
import FlashcardMock from "../styled/FlashcardMock";

const FlashcardCarouselSkeletonLoading = () => {
    return (
        <FlashcardMock onClick={noop} style={{ width: "100%", flex: 1 }}>
            <FlexRowAlignCenter style={{ justifyContent: "space-between", width: "100%" }}>
                <Skeleton animation="wave" variant="text" style={{ height: "4.3rem", width: "5rem" }} />
                <Skeleton animation="wave" variant="text" style={{ height: "4.3rem", width: "3.3rem" }} />
            </FlexRowAlignCenter>
            <Skeleton
                animation="wave"
                variant="text"
                style={{ height: "5.5rem", width: "30%", margin: "auto", borderRadius: "1rem" }}
            />
            <Skeleton
                animation="wave"
                variant="text"
                style={{ height: "3.5rem", width: "40%", margin: "0.5rem 0", borderRadius: "0.5rem" }}
            />
        </FlashcardMock>
    );
};

export default FlashcardCarouselSkeletonLoading;
